import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from '../../../TagRequest';

import { IAnalyticsExtConnectionSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';

export type IAddAnalyticsExtConnectionSettingsResult = ITagResult & IAnalyticsExtConnectionSettings;

export class AddAnalyticsExtConnectionSettingsRequest extends TagRequest<IAnalyticsExtConnectionSettings, IAddAnalyticsExtConnectionSettingsResult> {
  constructor(params: IAnalyticsExtConnectionSettings) {
    super('analyticsextensions', 'addAnalyticsExtensionsConnection', params);
  }
}
